import React, { useState } from "react";
import DataTable from "../../../../components/AdminTable/DataTable";
import { languageHelper } from "../../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function LoyaltyPointsReport() {
  const columns = [
    {
      header: languageHelper(defaultLang, "SN") || "SN",
      accessorKey: "SN",
    },
    {
      header: languageHelper(defaultLang, "Customer Name") || "Customer Name",
      accessorKey: "Customer Name",
    },
    {
      header: languageHelper(defaultLang, "Phone") || "Phone",
      accessorKey: "Phone",
    }, {
      header: languageHelper(defaultLang, "Earned Points") || "Earned Points",
      accessorKey: "Earned Points",
    }, {
      header: languageHelper(defaultLang, "Spent Points") || "Spent Points",
      accessorKey: "Spent Points",
    }, {
      header: languageHelper(defaultLang, "Earned Points") || "Earned Points",
      accessorKey: "Earned Points",
    },
  ];
  const [data] = useState([]);

  return (
    <main className="my-16">
      <div className="text-d-bg-text text-3xl text-center my-4">
      {languageHelper(defaultLang, "Loyalty Points Report")}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <DataTable columns={columns} data={data} />
    </main>
  );
}

export default LoyaltyPointsReport
;

